<div class="app-rating__wrapper" [ngClass]="textDirection">
  <opac-rating
    appStopPropagation
    [disabled]="readOnly"
    [rating]="displayRating"
    [ratedByUser]="byUser"
    (change)="onRateChange($event)"
  ></opac-rating>
</div>
